import { useRef } from "react";
import { NavigationContextProvider } from ".";
import { ErrorBoundary2 } from "@/pages/ErrorBoundary2";

type NavigationProviderProps = { children: React.ReactNode };
export function NavigationProvider({ children }: NavigationProviderProps) {
    const balanceSectionRef = useRef(null);
    const journeySectionRef = useRef(null);
    const bookingSectionRef = useRef(null);
    
    return (
        <NavigationContextProvider value={{
            balanceSectionRef,
            journeySectionRef,
            bookingSectionRef,
        }}>
            <ErrorBoundary2 msg="NavigationProvider Inner">
                {children}
            </ErrorBoundary2>
        </NavigationContextProvider>
    );
}